$(function () {
	let $people = $('.person');
	let justClicked = false;
	let windowWidth = window.innerWidth;

	$people.each(function () {
		let $person = $(this);
		let $back = $person.find('.blue-icon-close');
		let $front = $person.find('.person__front');
		let $bio = $person.find('.person__back__bio');

		// Transition on click only necessary if not the condensed version
		if (!$person[0].closest('.person--condensed') && !$person[0].matches('.person--expanding')) {
			$front.on('click', flip);
			$back.on('click', flipBack);
			$bio.css('overflow', 'hidden');
		} else if ($person[0].matches('.person--expanding')) {
			let $close = $person.find('.person__expander-close');
			$person.attr('tabindex', '0');
			$front.on('click', (e) => expand(e.target, true));
			$person.on('keydown', (e) => {
				if (e.keyCode === 13 && !e.target.matches("button.person__expander-close")) expand(e.target, true);
			});
			$close.on('click', (e) => {
				e.preventDefault();
				expand(e.target, false);
			});
		}
	});

	function flip() {
		let $trigger = $(this);
		let $card = $trigger.closest('.person');
		let $bio = $card.find('.person__back__bio');

		if ($card.hasClass('person') && !$card.hasClass('back')) {
			$card.toggleClass('person__flip');
			$card.toggleClass('person');
			$card.toggleClass('back');
			$bio.css('overflow', 'auto');
		}
	}

	function flipBack() {
		let $trigger = $(this);
		let $card = $trigger.closest('.person__flip');
		let $bio = $card.find('.person__back__bio');

		if ($card.hasClass('back') && !$card.hasClass('person')) {
			$card.toggleClass('person__flip');
			$card.toggleClass('person');
			$card.toggleClass('back');
			$bio.css('overflow', 'hidden');
		}
	}

	function setExpanderDims(exp, card, container) {
		let paddingL = parseInt(container.css('padding-left'));
		let fullWidth = container.width();
		exp.css('width', `${fullWidth}px`);

		let offsetLeft = container[0].getBoundingClientRect().left - card[0].getBoundingClientRect().left  + paddingL;

		exp.css('left', `${offsetLeft}px`);
	}

	function setMarginVals(cards, margin) {
		cards.forEach(card => card.style.marginBottom = `${margin}px`);
	}

	function animateExpander(exp, open) {
		justClicked = true;
		let $card = exp.closest('.person--expanding');
		let $close = $card.find('.person__expander-close');

		if (($card[0].matches('.is-active') && open) || (!$card[0].matches(".is-active") && !open)) return;

		let $container = exp.closest('.container');
		if ($container.length == 0 && window.location.href.includes("localhost")) $container = exp.closest(".styleguide__markup__block");

		setExpanderDims(exp, $card, $container);

		let siblingCards = $container.find('.person--expanding').not($card);
		
		let sameRowSiblings = siblingCards.filter((i, card) => {
			return card.getBoundingClientRect().top === $card[0].getBoundingClientRect().top;
		});

		let start = exp.height();
		if (open) {
			$card.addClass('is-active');
			exp.attr("aria-hidden", "false")
		}	else {
			$card.removeClass('is-active');
			setTimeout(() => exp.attr("aria-hidden", "true"), 500);
		}
		let end = exp.height();
		let margin = open ? end + 40 : 0;
		setMarginVals([$card[0], ...sameRowSiblings], margin);
		exp[0].animate([
			{height: `${start}px`},
			{height: `${end}px`}
		], {
			duration: 500,
			easing: 'ease'
		});
		if (open) setTimeout(() => $close[0].focus(), 50);
		setTimeout(() => justClicked = false, 500);
	}

	function expand(target, open) {
		if (justClicked) return;
		let $trigger = $(target);
		let $card = $trigger.closest('.person.person--expanding');
		let $expander = $card.find('.person__expander');
		let $container = $card.closest('.container');

		let expandedCard = $container.find('.person--expanding.is-active');
		if (!expandedCard.length) {
			// if no card is open, animate open (focus on close button occurs in animateExpander)
			animateExpander($expander, open);
		} else if (expandedCard[0] == $card[0]) {
			// if only closing open card and not opening another, animate close and focus on newly-closed card
			animateExpander($expander, false);
			$card[0].focus();
		} else if (!!expandedCard.length && expandedCard[0] != $card[0]) {
			// if opening a new card while another is open, close the open card and open the new one
			animateExpander(expandedCard.find('.person__expander'), false);
			animateExpander($expander, open);
		}
	}

	const handleResize = () => {
		let $openExpanderCards = $('.person--expanding.is-active');
		let newWindowWidth = window.innerWidth;
		const lgBreakpoint = 992;

		if (!!$openExpanderCards.length) {
			if ((windowWidth >= lgBreakpoint && newWindowWidth < lgBreakpoint) || (windowWidth < lgBreakpoint && newWindowWidth >= lgBreakpoint)) {
				$openExpanderCards.each((i, card) => {
					let $exp = $(card).find('.person__expander');
					animateExpander($exp, false);
				});
				setMarginVals([...document.querySelectorAll(".person--expanding")], 0);
			} else {
				$openExpanderCards.each((i, card) => {
					let $exp = $(card).find('.person__expander');
					let $container = $(card).closest('.container');
					let siblingCards = [...document.querySelectorAll('.person--expanding')].filter(c => c != card);
					let sameRowSiblings = siblingCards.filter((c, i) => {
						return c.getBoundingClientRect().top === card.getBoundingClientRect().top;
					});
					setTimeout(() => {
						setExpanderDims($exp, $(card), $container);
						setTimeout(() => setMarginVals([card, ...sameRowSiblings], $exp.height() + 40), 500);
					}, 500);
				});
			}
		}

		windowWidth = newWindowWidth;
	}

	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			handleResize();
		}, 500);
	});
});
